function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["gutterX"],
  _excluded2 = ["transparent"],
  _excluded3 = ["children"],
  _excluded4 = ["minSections"],
  _excluded5 = ["children", "open"];
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import throttle from 'lodash.throttle';
import React from 'react';
import { AnchorNavigation } from '../AnchorNavigation/AnchorNavigation';
import { useAnchorNavigationContext } from '../AnchorNavigation/AnchorNavigationProvider';
import { Grid as BaseGrid } from '../Grid/Grid';
import { TearsheetContext } from '../Tearsheet/Tearsheet';
import { useResize } from '../_hooks/Resize';
import { useScroll } from '../_hooks/Scroll';
import { useUpdateEffect } from '../_hooks/useUpdateEffect';
import { addSubcomponents } from '../_utils/addSubcomponents';
import { mergeRefs } from '../_utils/mergeRefs';
import { pageLayoutRootDataAttr } from './PageLayout.constants';
import { animationDuration, StyledAside, StyledAsideFluidContainer, StyledAsidePanel, StyledBody, StyledContent, StyledFooter, StyledNavigation, StyledPageBanner, StyledPageBreadcrumbs, StyledPageContainer, StyledPageHeader, StyledPageMain, StyledPageTabs, StyledPageTitle } from './PageLayout.styles';
import { getBottomOffsetForFooterUseCase, getGlobalBottomOffset, getGlobalTopOffset, getIsIntersectingVertically, getRightOffset, wait } from './PageLayout.utils';
var defaultAsideIsOpen = false;
export var PageContext = /*#__PURE__*/React.createContext({
  bodyRef: /*#__PURE__*/React.createRef(),
  footerRef: /*#__PURE__*/React.createRef(),
  containerRef: /*#__PURE__*/React.createRef(),
  navigationRef: /*#__PURE__*/React.createRef(),
  aside: {
    open: function open() {
      return Promise.resolve();
    },
    close: function close() {
      return Promise.resolve();
    },
    isOpen: defaultAsideIsOpen
  }
});

// for some reason this does not appear in the deprecated in typedoc generated json, but Page.Row does
/**
 * @parent Page
 * @deprecated A wrapper around Grid, please use Grid instead. Page already sets
 * a default gutterX in context for children grid components.
 *
 * BEFORE `Page.Grid`, `Page.Row`, `Page.Column`
 *
 * AFTER `Grid` `Grid.Row` `Grid.Col`
 * @deprecatedSince 12
 */
export var Grid = function Grid(_ref) {
  var gutterX = _ref.gutterX,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(BaseGrid, _extends({
    gutterX: gutterX !== null && gutterX !== void 0 ? gutterX : 'lg'
  }, props));
};

/**
 * @parent Page
 * @deprecated A wrapper around Grid, please use Grid instead. Page already sets
 * a default gutterX in context for children grid components.
 *
 * BEFORE `Page.Row` AFTER `Grid.Row`
 * @deprecatedSince 12
 */
export var Row = BaseGrid.Row;

/**
 * @parent Page
 * @deprecated A wrapper around Grid, please use Grid instead. Page already sets
 * a default gutterX in context for children grid components.
 *
 * BEFORE `Page.Column` AFTER `Grid.Col`
 * @deprecatedSince 12
 */
export var Column = BaseGrid.Col;
var PageHeader = /*#__PURE__*/React.forwardRef(function PageHeader(_ref2, ref) {
  var transparent = _ref2.transparent,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(StyledPageHeader, _extends({
    $transparent: transparent
  }, props, {
    ref: ref
  }));
});
var PageBody = /*#__PURE__*/React.forwardRef(function PageBody(_ref3, ref) {
  var children = _ref3.children,
    props = _objectWithoutProperties(_ref3, _excluded3);
  var _React$useContext = React.useContext(PageContext),
    bodyRef = _React$useContext.bodyRef;
  var navigation;
  var content = [];
  React.Children.forEach(children, function (child) {
    if (! /*#__PURE__*/React.isValidElement(child)) return;
    if (child.type === PageBodyNavigation) {
      navigation = child;
    } else {
      content.push(child);
    }
  });
  if (!navigation) {
    return /*#__PURE__*/React.createElement(StyledBody, _extends({
      children: children
    }, props, {
      ref: mergeRefs(ref, bodyRef)
    }));
  }
  return /*#__PURE__*/React.createElement(StyledBody, _extends({}, props, {
    ref: mergeRefs(ref, bodyRef)
  }), /*#__PURE__*/React.createElement(StyledNavigation, null, navigation), /*#__PURE__*/React.createElement(StyledContent, null, content));
});
export var PageBodyNavigation = /*#__PURE__*/React.forwardRef(function (_ref4, ref) {
  var _props$sections$lengt, _props$sections, _props$sections2, _props$selected, _props$onSelect;
  var _ref4$minSections = _ref4.minSections,
    minSections = _ref4$minSections === void 0 ? 2 : _ref4$minSections,
    props = _objectWithoutProperties(_ref4, _excluded4);
  var _React$useContext2 = React.useContext(PageContext),
    navigationRef = _React$useContext2.navigationRef;
  var _useAnchorNavigationC = useAnchorNavigationContext(),
    sections = _useAnchorNavigationC.sections,
    selected = _useAnchorNavigationC.selected,
    onSelect = _useAnchorNavigationC.onSelect;
  var sectionsLength = (_props$sections$lengt = (_props$sections = props.sections) === null || _props$sections === void 0 ? void 0 : _props$sections.length) !== null && _props$sections$lengt !== void 0 ? _props$sections$lengt : sections.length;
  if (sectionsLength < minSections) return null;
  return /*#__PURE__*/React.createElement(AnchorNavigation, _extends({
    ref: mergeRefs(ref, navigationRef),
    sections: (_props$sections2 = props.sections) !== null && _props$sections2 !== void 0 ? _props$sections2 : sections,
    selected: (_props$selected = props.selected) !== null && _props$selected !== void 0 ? _props$selected : selected,
    onSelect: (_props$onSelect = props.onSelect) !== null && _props$onSelect !== void 0 ? _props$onSelect : onSelect
  }, props));
});
var PageFooter = /*#__PURE__*/React.forwardRef(function PageFooter(props, ref) {
  var _React$useContext3 = React.useContext(PageContext),
    bodyRef = _React$useContext3.bodyRef,
    footerRef = _React$useContext3.footerRef,
    aside = _React$useContext3.aside;
  var _React$useContext4 = React.useContext(TearsheetContext),
    addListener = _React$useContext4.addListener;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isIntersectingWithBody = _React$useState2[0],
    setIsIntersectingWithBody = _React$useState2[1];
  function calculateIntersections() {
    if (!footerRef.current || !bodyRef.current) {
      return;
    }
    setIsIntersectingWithBody(getIsIntersectingVertically(bodyRef.current, footerRef.current));
  }
  React.useEffect(function () {
    var _bodyRef$current;
    var tabWasPressed = false;
    var onActiveElementChange = function onActiveElementChange() {
      if (tabWasPressed && footerRef.current && document.activeElement && getIsIntersectingVertically(document.activeElement, footerRef.current)) {
        document.activeElement.scrollIntoView();
      }
    };
    var onKeyDown = function onKeyDown(e) {
      if (e.code === 'Tab') {
        tabWasPressed = true;
        // setTimeout is added to the end of async queue
        // after all already attached eventListeners
        // `tabWasPressed` marked as `false` after all events
        // which can be triggered by pressing Tab
        setTimeout(function () {
          tabWasPressed = false;
        }, 0);
      }
    };
    (_bodyRef$current = bodyRef.current) === null || _bodyRef$current === void 0 ? void 0 : _bodyRef$current.addEventListener('focusin', onActiveElementChange);
    document.addEventListener('keydown', onKeyDown, true);
    return function () {
      var _bodyRef$current2;
      (_bodyRef$current2 = bodyRef.current) === null || _bodyRef$current2 === void 0 ? void 0 : _bodyRef$current2.removeEventListener('focusin', onActiveElementChange);
      document.removeEventListener('keydown', onKeyDown, true);
    };
  }, []);
  React.useEffect(function () {
    return addListener('scroll', calculateIntersections);
  }, []);
  React.useEffect(calculateIntersections, []);
  useScroll({
    onScroll: calculateIntersections
  });
  useResize({
    onResize: calculateIntersections
  });
  return /*#__PURE__*/React.createElement(StyledFooter, _extends({}, props, {
    $isAsideOpen: aside.isOpen,
    $hasShadow: isIntersectingWithBody,
    "data-sticky": isIntersectingWithBody ? 'sticky' : '',
    ref: mergeRefs(ref, footerRef)
  }));
});
var PageAside = /*#__PURE__*/React.forwardRef(function PageAside(_ref5, ref) {
  var children = _ref5.children,
    controlledIsOpen = _ref5.open,
    props = _objectWithoutProperties(_ref5, _excluded5);
  var _React$useContext5 = React.useContext(PageContext),
    _React$useContext5$as = _React$useContext5.aside,
    contextIsOpen = _React$useContext5$as.isOpen,
    open = _React$useContext5$as.open,
    close = _React$useContext5$as.close;
  var _React$useContext6 = React.useContext(TearsheetContext),
    tearsheetPlacement = _React$useContext6.placement,
    addTearsheetListener = _React$useContext6.addListener;
  var _React$useContext7 = React.useContext(PageContext),
    footerRef = _React$useContext7.footerRef,
    containerRef = _React$useContext7.containerRef;
  var innerRef = React.useRef(null);
  var _React$useState3 = React.useState(null),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    topOffset = _React$useState4[0],
    setTopOffset = _React$useState4[1];
  var _React$useState5 = React.useState(0),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    bottomOffset = _React$useState6[0],
    setBottomOffset = _React$useState6[1];
  var _React$useState7 = React.useState(0),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    rightOffset = _React$useState8[0],
    setRightOffset = _React$useState8[1];
  var initialIsOpen = controlledIsOpen !== null && controlledIsOpen !== void 0 ? controlledIsOpen : contextIsOpen;
  var _React$useState9 = React.useState(initialIsOpen ? 'open' : 'closed'),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    animationStatus = _React$useState10[0],
    setAnimationStatus = _React$useState10[1];
  var _React$useState11 = React.useState(initialIsOpen),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    isOpen = _React$useState12[0],
    setIsOpen = _React$useState12[1];
  var throttledToggle = React.useCallback(throttle(function (isOpen) {
    if (isOpen) {
      open();
    } else {
      close();
    }
  },
  // wait just a little longer than the animation duration to avoid odd blinking
  animationDuration.panel + 100, {
    trailing: true
  }), []);
  React.useEffect(function () {
    throttledToggle(controlledIsOpen);
  }, [controlledIsOpen, throttledToggle]);
  React.useEffect(function () {
    setIsOpen(contextIsOpen);
  }, []);
  useUpdateEffect(function () {
    ;
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!contextIsOpen) {
              _context.next = 9;
              break;
            }
            setIsOpen(true);

            // allow browsers to recalculate the layout
            _context.next = 4;
            return wait(0);
          case 4:
            setAnimationStatus('opening');
            _context.next = 7;
            return wait(animationDuration.panel);
          case 7:
            setAnimationStatus('open');
            return _context.abrupt("return");
          case 9:
            setAnimationStatus('closing');
            _context.next = 12;
            return wait(animationDuration.panel);
          case 12:
            setAnimationStatus('closed');
            setIsOpen(false);
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }, [contextIsOpen]);
  function calculateOffsets() {
    calculateHorizontalOffsets();
    calculateVerticalOffsets();
  }
  function calculateHorizontalOffsets() {
    if (!containerRef.current) {
      return;
    }
    setRightOffset(getRightOffset(containerRef.current));
  }
  function calculateVerticalOffsets() {
    if (!innerRef.current || !containerRef.current) {
      return;
    }
    var globalTopOffset = getGlobalTopOffset(containerRef.current);
    setTopOffset(globalTopOffset);
    var globalBottomOffset = getGlobalBottomOffset(containerRef.current);
    setBottomOffset(globalBottomOffset);
    if (!footerRef.current) {
      return;
    }
    var bottomOffset = getBottomOffsetForFooterUseCase(footerRef.current, globalBottomOffset);
    if (bottomOffset !== null) {
      setBottomOffset(bottomOffset);
    }
  }
  useScroll({
    onScroll: calculateOffsets
  });
  useResize({
    onResize: calculateOffsets
  });
  React.useEffect(function () {
    if (tearsheetPlacement) {
      return addTearsheetListener('afterShow', calculateOffsets);
    }
    calculateOffsets();
  }, []);
  useUpdateEffect(calculateOffsets, [contextIsOpen, animationStatus]);
  var asideOpen = ['open', 'opening'].includes(animationStatus);
  var asideClosed = ['closed', 'closing'].includes(animationStatus);
  return isOpen ? /*#__PURE__*/React.createElement(StyledAside, _extends({}, props, {
    $open: asideOpen,
    $closed: asideClosed,
    ref: mergeRefs(ref, innerRef, calculateOffsets)
  }), /*#__PURE__*/React.createElement(StyledAsideFluidContainer, {
    $open: asideOpen,
    $closed: asideClosed
  }, /*#__PURE__*/React.createElement(StyledAsidePanel, {
    $offsetTop: topOffset,
    $rightOffset: rightOffset,
    $minusHeight: (topOffset !== null && topOffset !== void 0 ? topOffset : 0) + bottomOffset,
    $closing: animationStatus === 'closing',
    $opening: animationStatus === 'opening',
    $closed: animationStatus === 'closed',
    $altAnimation: tearsheetPlacement === 'left'
  }, children))) : null;
});
var PageContainer = /*#__PURE__*/React.forwardRef(function PageContainer(props, ref) {
  var _React$useState13 = React.useState(defaultAsideIsOpen),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    isAsideOpen = _React$useState14[0],
    setIsAsideOpen = _React$useState14[1];
  var openAside = function openAside() {
    setIsAsideOpen(true);
    return wait(animationDuration.panel);
  };
  var closeAside = function closeAside() {
    setIsAsideOpen(false);
    return wait(animationDuration.panel);
  };
  var containerRef = React.useRef(null);
  var bodyRef = React.useRef(null);
  var navigationRef = React.useRef(null);
  var footerRef = React.useRef(null);
  return /*#__PURE__*/React.createElement(PageContext.Provider, {
    value: {
      bodyRef: bodyRef,
      footerRef: footerRef,
      containerRef: containerRef,
      navigationRef: navigationRef,
      aside: {
        open: openAside,
        close: closeAside,
        isOpen: isAsideOpen
      }
    }
  }, /*#__PURE__*/React.createElement(StyledPageContainer, _extends({
    "data-core-react": "page"
  }, props, {
    ref: mergeRefs(ref, containerRef)
  })));
});
var PageMain = /*#__PURE__*/React.forwardRef(function PageMain(props, ref) {
  var _React$useContext8 = React.useContext(TearsheetContext),
    tearsheetPlacement = _React$useContext8.placement;
  var attrs = _defineProperty({}, pageLayoutRootDataAttr, true);
  return /*#__PURE__*/React.createElement(Grid, {
    gutterX: "lg"
  }, /*#__PURE__*/React.createElement(StyledPageMain, _extends({}, props, attrs, {
    ref: ref,
    $tearsheetPlacement: tearsheetPlacement
  })));
});
var PageBreadcrumbs = /*#__PURE__*/React.forwardRef(function PageBreadcrumbs(props, ref) {
  return /*#__PURE__*/React.createElement(StyledPageBreadcrumbs, _extends({
    ref: ref
  }, props));
});
var PageBanner = /*#__PURE__*/React.forwardRef(function PageBanner(props, ref) {
  return /*#__PURE__*/React.createElement(StyledPageBanner, _extends({
    ref: ref
  }, props));
});
var PageTitle = /*#__PURE__*/React.forwardRef(function PageTitle(props, ref) {
  return /*#__PURE__*/React.createElement(StyledPageTitle, _extends({
    ref: ref
  }, props));
});
var PageTabs = /*#__PURE__*/React.forwardRef(function PageTabs(props, ref) {
  return /*#__PURE__*/React.createElement(StyledPageTabs, _extends({
    ref: ref
  }, props));
});
Grid.displayName = 'Page.Grid';
PageHeader.displayName = 'Page.Header';
PageBanner.displayName = 'Page.Banner';
PageBreadcrumbs.displayName = 'Page.Breadcrumbs';
PageTitle.displayName = 'Page.Title';
PageTabs.displayName = 'Page.Tabs';
PageBody.displayName = 'Page.Body';
PageFooter.displayName = 'Page.Footer';
PageAside.displayName = 'Page.Aside';
PageContainer.displayName = 'Page';
PageMain.displayName = 'Page.Main';

/**
  Building block elements for layout that should be used to build a common skeleton of a page.
  - Page
    - Page.Main
      - Page.Header
        - Page.Breadcrumbs
          - Breadcrumbs
        - Page.Banner
          - Banner
        - Page.Title
          - Title or H1
        - Page.Tabs
          - Tabs
      - Page.Body
      - Page.Footer
    - Page.Aside
Other helpers, such as Page.Grid, Page.Row and Page.Column are thin wrappers over Grid components and share the same API.
 */
export var Page = addSubcomponents({
  Header: PageHeader,
  Banner: PageBanner,
  Breadcrumbs: PageBreadcrumbs,
  Title: PageTitle,
  Tabs: PageTabs,
  Footer: PageFooter,
  Body: PageBody,
  Main: PageMain,
  Aside: PageAside,
  // Grid utilities
  /**
   * @deprecated A wrapper around Grid, please use Grid instead. Page already sets
   * a default gutterX in context for children grid components.
   *
   * BEFORE `Page.Grid` AFTER `Grid` (or `Grid gutterX="lg"`)
   * @deprecatedSince 12
   */
  Grid: Grid,
  /**
   * @deprecated A wrapper around Grid, please use Grid instead. Page already sets
   * a default gutterX in context for children grid components.
   *
   * BEFORE `Page.Column` AFTER `Grid.Col`
   * @deprecatedSince 12
   */
  Column: Column,
  /**
   * @deprecated A wrapper around Grid, please use Grid instead. Page already sets
   * a default gutterX in context for children grid components.
   *
   * BEFORE `Page.Row` AFTER `Grid.Row`
   * @deprecatedSince 12
   */
  Row: Row
}, PageContainer);
//# sourceMappingURL=PageLayout.js.map